module.exports = __webpack_public_path__ + "img/202204121438340260yw.0a4b9046.jpg";